import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { TourProvider } from './tour/TourContext';
import { DemoProvider } from './components/DemoModal';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import Yards from './pages/Yards';
import Sites from './pages/Sites';
import DeliveryRecords from './pages/DeliveryRecords';
import Orders from './pages/Orders';
import Import from './pages/Import';
import Login from './pages/Login';
import Profile from './pages/Profile';

export default function App() {
  const { loading, session } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }} className="muted">
        Loading…
      </div>
    );
  }

  // Demo mode: signing in (email OTP) is all that's required — no team setup.
  if (!session) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <DemoProvider>
    <TourProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/yards" element={<Yards />} />
          <Route path="/sites" element={<Sites />} />
          <Route path="/records" element={<DeliveryRecords />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/import" element={<Import />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </TourProvider>
    </DemoProvider>
  );
}
